import api from "../api/axios"

export const getProductSales = async () => {
  const res = await api.get("/product-sales")
  return res.data
}

export const getProductSale = async (id) => {
  const res = await api.get(`/product-sales/${id}`)
  return res.data
}

export const createProductSale = async (data) => {
  const res = await api.post("/product-sales", data)
  return res.data
}

export const downloadProductSaleInvoice = async (saleId) => {
  const res = await api.get(`/product-sales/${saleId}/invoice`, { responseType: "blob" })
  const blob = new Blob([res.data], { type: "application/pdf" })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = `facture-produit-${saleId}.pdf`
  a.click()
  window.URL.revokeObjectURL(url)
}
